/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React from 'react'
import {IconButton} from '@mui/material'
import {MoreVert} from '@mui/icons-material'

export const AppContextMenuButton: React.FC<{
  setMenuAnchor: (el: Element) => void
}> = ({setMenuAnchor}) => {
  return (
    <IconButton
      onClick={(event: any) => {
        setMenuAnchor(event.currentTarget)
      }}
      size='large'
    >
      <MoreVert />
    </IconButton>
  )
}
